export type SplitFileName = {
  baseName: string;
  extension: string;
};

/*
 * Splits on the last dot so names with extra dots (e.g. "Approval.v2.pdf")
 * keep their full base name and real extension.
 */
export const splitFileName = (fileName: string): SplitFileName => {
  const lastDotIndex = fileName.lastIndexOf('.');
  if (lastDotIndex <= 0 || lastDotIndex === fileName.length - 1) {
    return { baseName: fileName, extension: '' };
  }
  return {
    baseName: fileName.substring(0, lastDotIndex),
    extension: fileName.substring(lastDotIndex + 1),
  };
};

export const getTruncatedDisplayFileName = (fileName: string, maxBaseNameLength: number): string => {
  const { baseName, extension } = splitFileName(fileName);
  const displayBaseName =
    baseName.length > maxBaseNameLength ? `${baseName.substring(0, maxBaseNameLength)}[...]` : baseName;
  return extension ? `${displayBaseName}.${extension}` : displayBaseName;
};
